import React from 'react'

const ImageSection = (props) => {
  return (
    <div className="col-md-2 hidden-xs hidden-sm about-img-div">
      <img src={props.imgPath} width="400" className="img-responsive" alt="" align="right" />
    </div>
  )
}

export default ImageSection
